import { formatTime } from "./utils";

export default function DoneCard({ order }) {
  const duration = order.closed_at
    ? Math.round(
        (new Date(order.closed_at.replace(" ", "T") + "Z") - new Date(order.created_at.replace(" ", "T") + "Z")) / 60000
      )
    : null;

  return (
    <div className="done-card">
      <div className="done-header">
        <span className="done-table">{order.table_label}</span>
        <span className="done-id">#{order.id}</span>
        <span className="done-time">{formatTime(order.created_at)}</span>
        {duration !== null && (
          <span className="done-duration">{duration}dk</span>
        )}
      </div>
      <div className="done-items">
        {order.items?.map((i) => (
          <span key={i.id} className="done-item">
            {i.quantity}× {i.product_name}
          </span>
        ))}
      </div>
      <div className="done-footer">
        <span className="done-total">₺{order.total_amount?.toLocaleString("tr-TR")}</span>
      </div>
    </div>
  );
}
